import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Checkbox, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link, StyledCheckbox } from './styledComponents';
import Button from '@mui/material/Button';
import usePreserveQueryString from './hooks/usePreserveQueryString';

export const ControlBox = styled(Box, {
    shouldForwardProp: prop => prop !== 'isCompact',
})<{ isCompact?: boolean }>(({ isCompact }) => ({
    height: isCompact ? '125px' : '145px',
    textAlign: 'center',
}));

interface Props {
    isPasswordLoginShowing: boolean;
    isMfaShowing: boolean;
    isPublicComputer: boolean;
    onPublicChange: (v: boolean) => void;
    onResendCode: () => void;
    isResendCodeDisabled: boolean;
}
const FormController = ({
    isPasswordLoginShowing,
    isMfaShowing,
    onResendCode,
    isResendCodeDisabled,
    isPublicComputer,
    onPublicChange,
}: Props) => {
    const queryString = usePreserveQueryString();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onPublicChange(event.target.checked);
    };

    return (
        <ControlBox isCompact={!isPasswordLoginShowing}>
            {!isPasswordLoginShowing && !isMfaShowing && (
                <Box mt="20px">
                    <Typography color="gray" fontSize="12px" mb="10px">
                        Don't have an account?
                    </Typography>
                    <Link to={`/create${queryString}`}>Create one for free</Link>
                </Box>
            )}
            {isPasswordLoginShowing && !isMfaShowing && (
                <Stack
                    direction="column"
                    spacing={2}
                    sx={{
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }}
                >
                    <div style={{ width: '100%', textAlign: 'left' }}>
                        <StyledCheckbox
                            label="Using a public computer?"
                            control={
                                <Checkbox
                                    size="small"
                                    checked={isPublicComputer}
                                    onChange={handleChange}
                                />
                            }
                        />
                    </div>
                    <Link to={`/password${queryString}`}>Forgot Password</Link>
                </Stack>
            )}
            {isMfaShowing && (
                <Stack
                    direction="column"
                    spacing={2}
                    mt="10px"
                    sx={{
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }}
                >
                    <Button variant="text" onClick={onResendCode} disabled={isResendCodeDisabled}>
                        Resend the Code
                    </Button>
                </Stack>
            )}
        </ControlBox>
    );
};
export default FormController;
